const { BlobClient } = require("@azure/storage-blob");
var stringify = require('json-stable-stringify');
var entryManager = require('./entry-manager.js');
const crypto = require('crypto');

let sas = '';
let originalPasswordsSas = '';

let encryptedJson;
let rawJson;

export async function writeJson() {
    try {
        const blobClientRaw = new BlobClient(originalPasswordsSas);
        const downloadBlockBlobResponseRaw = await blobClientRaw.download();
        const downloadedRaw = await blobToString(await downloadBlockBlobResponseRaw.blobBody);
        var oldJsonRaw = JSON.parse(downloadedRaw);

        var newJson =
        {
            pairs: [
                { index: 'index_chris.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield1', 0, oldJsonRaw)), name: 'Oude man' },
                { index: 'index_dayo.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield2', 1, oldJsonRaw)), name: 'Co-assistent' },
                { index: 'index_kaltoum.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield3', 2, oldJsonRaw)), name: 'Moeder' },
                { index: 'index_roy.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield4', 3, oldJsonRaw)), name: 'Scholier' },
                { index: 'index_sollicitant.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield5', 4, oldJsonRaw)), name: 'Sollicitant' },
                { index: 'index_sollicitant_en.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield6', 5, oldJsonRaw)), name: 'Sollicitant en' },
                { index: 'index_kleedkamer.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield7', 6, oldJsonRaw)), name: 'Kleedkamer' },
                { index: 'index_kleedkamer_en.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield8', 7, oldJsonRaw)), name: 'Kleedkamer en' },
                { index: 'index_lunchpauze.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield9', 8, oldJsonRaw)), name: 'Lunchpauze' },
                { index: 'index_lunchpauze_en.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield10', 9, oldJsonRaw)), name: 'Lunchpauze en' },
                { index: 'index_huisbezichtiging.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield11', 10, oldJsonRaw)), name: 'Huisbezichtiging' },
                { index: 'index_huisbezichtiging_en.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield12', 11, oldJsonRaw)), name: 'Huisbezichtiging en' },
                { index: 'index_kantoor.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield13', 12, oldJsonRaw)), name: 'Kantoor' },
                { index: 'index_monteurs.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield14', 13, oldJsonRaw)), name: 'Monteurs' },
                { index: 'index_selectietraining.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield15', 14, oldJsonRaw)), name: 'Selectietraining' },

                { index: 'index_projectplanetnl.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield16', 15, oldJsonRaw)), name: 'Project Planet NL' },
                { index: 'index_projectplaneten.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield17', 16, oldJsonRaw)), name: 'Project Planet EN' },
                { index: 'index_mentaalfit.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield18', 17, oldJsonRaw)), name: 'Mentaal fit' },
                { index: 'index_obstipatie.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield19', 18, oldJsonRaw)), name: 'Obstipatie' },
                { index: 'index_badmeester.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield20', 19, oldJsonRaw)), name: 'Badmeester' },
                { index: 'index_damesgaanvoor.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield21', 20, oldJsonRaw)), name: 'Dames gaan voor' },
                { index: 'index_brandstof.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield22', 21, oldJsonRaw)), name: 'Brandstof' },
                { index: 'index_stage.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield23', 22, oldJsonRaw)), name: 'Stage' },
                { index: 'index_voetbal.html', paswordValue: createSHA256Hash(GetValueFromPasswordField('Passwordfield24', 23, oldJsonRaw)), name: 'Voetbal' },
            ]
        };

        var newJsonRaw =
        {
            pairs: [
                { index: 'index_chris.html', paswordValue: GetValueFromPasswordField('Passwordfield1', 0, oldJsonRaw), name: 'Oude man' },
                { index: 'index_dayo.html', paswordValue: GetValueFromPasswordField('Passwordfield2', 1, oldJsonRaw), name: 'Co-assistent' },
                { index: 'index_kaltoum.html', paswordValue: GetValueFromPasswordField('Passwordfield3', 2, oldJsonRaw), name: 'Moeder' },
                { index: 'index_roy.html', paswordValue: GetValueFromPasswordField('Passwordfield4', 3, oldJsonRaw), name: 'Scholier' },
                { index: 'index_sollicitant.html', paswordValue: GetValueFromPasswordField('Passwordfield5', 4, oldJsonRaw), name: 'Sollicitant' },
                { index: 'index_sollicitant_en.html', paswordValue: GetValueFromPasswordField('Passwordfield6', 5, oldJsonRaw), name: 'Sollicitant en' },
                { index: 'index_kleedkamer.html', paswordValue: GetValueFromPasswordField('Passwordfield7', 6, oldJsonRaw), name: 'Kleedkamer' },
                { index: 'index_kleedkamer_en.html', paswordValue: GetValueFromPasswordField('Passwordfield8', 7, oldJsonRaw), name: 'Kleedkamer en' },
                { index: 'index_lunchpauze.html', paswordValue: GetValueFromPasswordField('Passwordfield9', 8, oldJsonRaw), name: 'Lunchpauze' },
                { index: 'index_lunchpauze_en.html', paswordValue: GetValueFromPasswordField('Passwordfield10', 9, oldJsonRaw), name: 'Lunchpauze en' },
                { index: 'index_huisbezichtiging.html', paswordValue: GetValueFromPasswordField('Passwordfield11', 10, oldJsonRaw), name: 'Huisbezichtiging' },
                { index: 'index_huisbezichtiging_en.html', paswordValue: GetValueFromPasswordField('Passwordfield12', 11, oldJsonRaw), name: 'Huisbezichtiging en' },
                { index: 'index_kantoor.html', paswordValue: GetValueFromPasswordField('Passwordfield13', 12, oldJsonRaw), name: 'Kantoor' },
                { index: 'index_monteurs.html', paswordValue: GetValueFromPasswordField('Passwordfield14', 13, oldJsonRaw), name: 'Monteurs' },
                { index: 'index_selectietraining.html', paswordValue: GetValueFromPasswordField('Passwordfield15', 14, oldJsonRaw), name: 'Selectietraining' },

                { index: 'index_projectplanetnl.html', paswordValue: GetValueFromPasswordField('Passwordfield16', 15, oldJsonRaw), name: 'Project Planet NL' },
                { index: 'index_projectplaneten.html', paswordValue: GetValueFromPasswordField('Passwordfield17', 16, oldJsonRaw), name: 'Project Planet EN' },
                { index: 'index_mentaalfit.html', paswordValue: GetValueFromPasswordField('Passwordfield18', 17, oldJsonRaw), name: 'Mentaal fit' },
                { index: 'index_obstipatie.html', paswordValue: GetValueFromPasswordField('Passwordfield19', 18, oldJsonRaw), name: 'Obstipatie' },
                { index: 'index_badmeester.html', paswordValue: GetValueFromPasswordField('Passwordfield20', 19, oldJsonRaw), name: 'Badmeester' },
                { index: 'index_damesgaanvoor.html', paswordValue: GetValueFromPasswordField('Passwordfield21', 20, oldJsonRaw), name: 'Dames gaan voor' },
                { index: 'index_brandstof.html', paswordValue: GetValueFromPasswordField('Passwordfield22', 21, oldJsonRaw), name: 'Brandstof' },
                { index: 'index_stage.html', paswordValue: GetValueFromPasswordField('Passwordfield23', 22, oldJsonRaw), name: 'Stage' },
                { index: 'index_voetbal.html', paswordValue: GetValueFromPasswordField('Passwordfield24', 23, oldJsonRaw), name: 'Voetbal' },
            ]
        };
        var newJsonToString = stringify(newJson);
        console.log("Content to upload: ", newJsonToString);

        var newJsonRawToString = stringify(newJsonRaw);
        console.log("Content to upload raw: ", newJsonRawToString);

        // Dont upload in when dev!!!
        //return;

        const blockBlobClientRaw = blobClientRaw.getBlockBlobClient();
        await blockBlobClientRaw.uploadBrowserData(newJsonRawToString, {
            maxSingleShotSize: 4 * 1024 * 1024
        });

        const blobClient = new BlobClient(sas);
        const blockBlobClient = blobClient.getBlockBlobClient();
        await blockBlobClient.uploadBrowserData(newJsonToString, {
            maxSingleShotSize: 4 * 1024 * 1024
        });
        window.alert("Opslaan gelukt");

    } catch (err) {
        window.alert("Er is iets misgegaan met het bewerken van de wachtwoorden. Controleer uw internet verbinding, en of de ingevulde acces key correct is");
    }

    async function blobToString(blob) {
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
            fileReader.onloadend = (ev) => {
                resolve(ev.target.result);
            };
            fileReader.onerror = reject;
            fileReader.readAsText(blob);
        });
    }

    function GetValueFromPasswordField(PasswordfieldName, currentPasswordIndex, jsondatas) {
        var password = jsondatas.pairs[currentPasswordIndex].paswordValue;
        var paswordField = document.getElementById(PasswordfieldName);
        if (paswordField != null) {
            if (paswordField.value) {
                password = paswordField.value;
            }
        }
        return password;
    }

}

export function init() {

    var element = document.getElementById("promt-for-key");
    if (element) {
        element.addEventListener("click", () => promtForKey());
    }

    var saveJsonButton = document.getElementById("saveJsonButton");
    if (saveJsonButton) {
        saveJsonButton.addEventListener("click", () => saveJson());
    }
}

async function populatePasswordFields() {
    const downloadedRawJson = await blobToString(await rawJson.blobBody);
    var rawPasswordJson = JSON.parse(downloadedRawJson);

    let index = 0;
    for (let i in rawPasswordJson.pairs) {
        setPasswordFieldAttribute(index, rawPasswordJson);
        index++;
    }
}

function setPasswordFieldAttribute(index, jsonData) {
    $('#Passwordfield' + (index + 1)).attr("placeholder", jsonData.pairs.length > index ? jsonData.pairs[index].paswordValue : "");
}

function createSHA256Hash(inputString) {
    const hash = crypto.createHash('sha256');
    hash.update(inputString);
    return hash.digest('hex');
}

async function saveJson() {
    await writeJson();
    console.log("written json");
}

async function promtForKey() {
    var password = prompt("Blob storage acces key", "");
    if (password != null) {
        const arr = password.split("//");
        sas = 'https://criticalmassmao.blob.core.windows.net/$web/entrydata.json?sv=2019-02-02&st=2020-09-03T11%3A26%3A15Z&se=2040-10-04T11%3A26%3A00Z&sr=b&sp=rw&sig=ni%2BF3RROsTNbleqZ%' + arr[0];
        originalPasswordsSas = 'https://criticalmassmao.blob.core.windows.net/$web/entrydataraw.json?sv=2023-01-03&st=2024-07-19T12%3A58%3A13Z&se=2117-10-20T12%3A58%3A00Z&sr=b&sp=rw&sig=7NW%2F7k7EMFeqyM1%' + arr[1];

        try {
            const blobClient = new BlobClient(sas);
            const originalPasswordsClient = new BlobClient(originalPasswordsSas);
            encryptedJson = await blobClient.download();
            rawJson = await originalPasswordsClient.download();

            populatePasswordFields();
            document.getElementById('amdin-password-editing-group').hidden = false;

        } catch (err) {
            window.alert("Authenticatie mislukt. Controleer uw internet verbinding, en of de ingevulde acces key correct is");
            document.getElementById('amdin-password-editing-group').hidden = true;
        }
    }
}

async function blobToString(blob) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onloadend = (ev) => {
            resolve(ev.target.result);
        };
        fileReader.onerror = reject;
        fileReader.readAsText(blob);
    });
}

document.addEventListener('DOMContentLoaded', init);